import { useInfiniteQuery } from '@tanstack/react-query';
import { getClinicOptionsPaginated } from '@/services/admin/clinics';

/**
 * Infinite-scroll hook for clinic options on the information create/edit form.
 * Loads 20 records per page, filtered by the currently selected tenant IDs.
 */
export const useInformationClinicOptions = (
  siteType: string,
  tenantIds: number[],
  options?: { enabled?: boolean }
) => {
  return useInfiniteQuery({
    queryKey: ['admin', siteType, 'clinics', 'options', 'information', tenantIds],
    queryFn: ({ pageParam }) =>
      getClinicOptionsPaginated(siteType, {
        tenant_ids: tenantIds,
        page: pageParam as number,
        per_page: 20,
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.meta.current_page < lastPage.meta.last_page
        ? lastPage.meta.current_page + 1
        : undefined,
    enabled: !!siteType && tenantIds.length > 0 && (options?.enabled ?? true),
  });
};
